module.exports = __webpack_public_path__ + "static/img/chat-pass.6fe0c6bb.png";